import keycloak from '../../keycloak';
import { config } from '../../utilities/config';

export async function fetchFavouriteReportsApi(organizationId, userId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/${userId}/add-to-favourite`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    }
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function createFavReportApi(organizationId, userId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/${userId}/add-to-favourite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function removeFavReportApi(organizationId, userId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/${userId}/add-to-favourite`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}
